// Enhanced pricing functionality for venom-pheromone-perfume-2 template
// This script extends the bundle functionality to show prices in the Add to Cart button

document.addEventListener('DOMContentLoaded', function() {
  // Wait for the main bundle script to load and initialize
  setTimeout(function() {
    console.log('new-pdp-2.js loaded'); // Debug log
    
    // Override the updateSubtotalAndSavings function to also update button prices
    if (typeof window.updateSubtotalAndSavings === 'function') {
      console.log('Found updateSubtotalAndSavings function'); // Debug log
      const originalUpdateFunction = window.updateSubtotalAndSavings;
      
      window.updateSubtotalAndSavings = function() {
        // Call the original function first
        originalUpdateFunction.call(this);
        
        // Then update the button prices
        updateButtonPrices();
      };
      
      // Also call it once initially
      setTimeout(updateButtonPrices, 100);
    } else {
      console.log('updateSubtotalAndSavings function not found, creating fallback'); // Debug log
      // If the function doesn't exist yet, create our own update function
      createButtonPriceUpdater();
    }
  }, 1000); // Increased wait time to 1 second
});

function updateButtonPrices() {
  console.log('updateButtonPrices called'); // Debug log
  
  // Get the current selected pack from the global variable
  let selectedPack = window.selectedPack || '3';
  console.log('Selected pack:', selectedPack); // Debug log
  
  // Fallback: get from DOM if global variable not available
  if (!window.selectedPack) {
    const selectedPackElement = document.querySelector('.lux-pack-option.lux-selected');
    if (selectedPackElement) {
      selectedPack = selectedPackElement.dataset.pack;
      console.log('Got pack from DOM:', selectedPack); // Debug log
    }
  }
  
  // Get product data (this should be available from the main script)
  const productDataElement = document.getElementById('productData');
  if (!productDataElement) {
    console.log('Product data not found'); // Debug log
    return;
  }
  
  const productData = JSON.parse(productDataElement.textContent);
  
  let originalPrice, finalPrice;
  
  // Calculate prices based on selected pack
  if (selectedPack === '3') {
    originalPrice = roundUpPrice(productData.threePackCompare);
    finalPrice = roundUpPrice(productData.threePackPrice);
  } else if (selectedPack === '2') {
    originalPrice = roundUpPrice(productData.twoPackCompare);
    finalPrice = roundUpPrice(productData.twoPackPrice);
  } else {
    originalPrice = roundUpPrice(productData.compareAtPrice);
    finalPrice = roundUpPrice(productData.price);
  }
  
  // Format the prices
  const formattedOriginal = (typeof Shopify !== 'undefined' && Shopify.formatMoney) ? 
    Shopify.formatMoney(originalPrice) : window.formatMoney(originalPrice);
  const formattedFinal = (typeof Shopify !== 'undefined' && Shopify.formatMoney) ? 
    Shopify.formatMoney(finalPrice) : window.formatMoney(finalPrice);
    
  console.log('Formatted prices:', formattedOriginal, formattedFinal); // Debug log

  // Update button prices (target the button specifically)
  const buttonOriginalPrice = document.querySelector('#lux-add-to-cart .original-price');
  const buttonFinalPrice = document.querySelector('#lux-add-to-cart .final-price');
  
  console.log('Button elements found:', !!buttonOriginalPrice, !!buttonFinalPrice); // Debug log
  
  if (buttonOriginalPrice && buttonFinalPrice) {
    buttonOriginalPrice.textContent = formattedOriginal;
    buttonFinalPrice.textContent = formattedFinal;
    console.log('Button prices updated successfully'); // Debug log
  } else {
    console.log('Button price elements not found'); // Debug log
  }

  // Only update button prices - removed main product price updates
}

function createButtonPriceUpdater() {
  // If the main functions don't exist, we'll create a basic version
  // This is a fallback in case the main script hasn't loaded yet
  
  // Helper functions (copies from main script)
  function roundUpPrice(cents) {
    return Math.ceil(cents / 100) * 100;
  }
  
  function formatMoney(cents) {
    var symbol = '$'; // Default symbol
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
      var symbols = {
        'USD': '$', 'EUR': '€', 'GBP': '£', 'CAD': '$', 'AUD': '$', 'JPY': '¥'
      };
      symbol = symbols[Shopify.currency.active] || Shopify.currency.active;
    }
    var dollars = cents / 100;
    var formatted = dollars.toFixed(2);
    return symbol + formatted;
  }
  
  // Create the update function
  window.updateButtonPricesOnly = function() {
    updateButtonPrices();
  };
  
  // Set up observers for pack changes
  const packOptions = document.querySelectorAll('.lux-pack-option');
  packOptions.forEach(option => {
    option.addEventListener('click', function() {
      setTimeout(updateButtonPrices, 100); // Small delay to ensure selection is updated
    });
  });
  
  // Also observe sticky pack options
  const stickyPackOptions = document.querySelectorAll('.pack-option');
  stickyPackOptions.forEach(option => {
    option.addEventListener('click', function() {
      setTimeout(updateButtonPrices, 100);
    });
  });
  
  console.log('Pack option observers set up:', packOptions.length, 'main options,', stickyPackOptions.length, 'sticky options');
  
  // Initial update
  setTimeout(updateButtonPrices, 1000);
}

// Make functions globally available if needed
if (typeof window.roundUpPrice === 'undefined') {
  window.roundUpPrice = function(cents) {
    return Math.ceil(cents / 100) * 100;
  };
}

if (typeof window.formatMoney === 'undefined') {
  window.formatMoney = function(cents) {
    var symbol = '$';
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
      var symbols = {
        'USD': '$', 'EUR': '€', 'GBP': '£', 'CAD': '$', 'AUD': '$', 'JPY': '¥'
      };
      symbol = symbols[Shopify.currency.active] || Shopify.currency.active;
    }
    var dollars = cents / 100;
    var formatted = dollars.toFixed(2);
    return symbol + formatted;
  };
}
